import React from 'react';

const HeroContext = React.createContext({
  clientInfo: {},
  textColor: '',
  landingInfo: {},
  sendMixpanelEvent: () => {},
});

export default HeroContext;
